import { useState, useMemo } from 'react'

const PROBLEMS: [number, number, string][] = [
  [7, 8, '×'], [12, 11, '×'], [6, 9, '×'], [15, 4, '×'],
  [23, 17, '+'], [48, 25, '+'], [33, 28, '+'], [19, 14, '+'],
  [72, 9, '÷'], [56, 7, '÷'], [81, 9, '÷'], [64, 8, '÷'],
]

function getRandomProblem(): { a: number; b: number; op: string; answer: number } {
  const tuple = PROBLEMS[Math.floor(Math.random() * PROBLEMS.length)]!
  const [a, b, op] = tuple
  const answer = op === '×' ? a * b : op === '+' ? a + b : op === '÷' ? a / b : 0
  return { a, b, op, answer }
}

interface MathGateProps {
  onSuccess: () => void
  onCancel: () => void
}

export function MathGate({ onSuccess, onCancel }: MathGateProps) {
  const { a, b, op, answer } = useMemo(getRandomProblem, [])
  const [value, setValue] = useState('')
  const [wrong, setWrong] = useState(false)

  const submit = () => {
    const n = parseInt(value.trim(), 10)
    if (n === answer) {
      onSuccess()
    } else {
      setWrong(true)
      setValue('')
    }
  }

  const symbol = op === '×' ? '×' : op === '+' ? '+' : '÷'

  return (
    <div className="page">
      <h1 className="page-title">Parent Mode</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>Solve to continue:</p>
      <p style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 16 }}>
        {a} {symbol} {b} = ?
      </p>
      {wrong && (
        <p style={{ color: 'var(--error)', marginBottom: 12 }}>Wrong. Try again.</p>
      )}
      <input
        type="number"
        inputMode="numeric"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && submit()}
        placeholder="Answer"
        style={{
          fontSize: '1.5rem',
          padding: 16,
          width: 140,
          textAlign: 'center',
          borderRadius: 'var(--radius)',
          border: '2px solid #e0e0e0',
          marginBottom: 20,
        }}
        autoFocus
      />
      <div style={{ display: 'flex', gap: 12 }}>
        <button type="button" className="btn-large btn-primary" onClick={submit}>
          OK
        </button>
        <button type="button" className="btn-large btn-secondary" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  )
}
